export const fields = {
  computed: {
    // All other sort removed because on the graphql api only allowed created_on & expires_on
    fields() {
      return [
        {
          key: 'name',
          label: this.$t('trackingTemp.form.linkName'),
          isRedirectable: true,
          thClass: 'mc-table--250',
          thStyle: 'min-width: 250px',
        },
        {
          key: 'createdOn',
          label: this.$t('trackingTemp.form.createdDate'),
          isSortable: true,
          sortKey: 'created_on',
          thClass: 'mc-table--170',
        },
        {
          key: 'expiresOn',
          label: this.$t('trackingTemp.form.expiredDate'),
          isSortable: true,
          sortKey: 'expires_on',
          thClass: 'mc-table--170',
        },
        // TODO: For future enhancement
        // {
        //   key: 'vehicledIds',
        //   label: this.$t('trackingTemp.form.licensePlate'),
        //   thClass: 'mc-table--170',
        // },
        {
          key: 'status',
          label: 'Status',
          thClass: 'mc-table--170',
        },
        {
          key: 'note',
          label: this.$t('trackingTemp.form.note'),
          thClass: 'mc-table--200',
        },
        {
          key: 'shareBtn',
          label: this.$t('trackingTemp.form.link'),
          thClass: 'mc-table--170',
        },
      ]
    },
  },
}
